export enum AppraiserDocumentType {
  LICENSE = 'LICENSE',
  POLICY = 'POLICY',
}

export enum AppraiserStatus {
  NEW = 'NEW',
  STANDARD = 'STANDARD',
  PREFERRED = 'PREFERRED',
  ESCALATED = 'ESCALATED',
}

export type Appraiser = {
  appraiserId: number;
  name: string;
  firm: string;
  phone: string;
  email: string;
  status: AppraiserStatus;
  licenseDocumentPath?: string;
  policyDocumentPath?: string;
};
